import { snackbar } from "@mobiscroll/react5";
import { postMutationUnAuth } from "src/components/ApolloConnection/UnauthorizedConnection/ApolloProviderSignup";
import {
  getQuery,
  postMutation,
} from "src/components/ApolloConnection/ApolloProviderComponent";
import {
  CANCEL_RAZORPAY_SUBSCRIPTION,
  CREATE_RAZORPAY_PLAN,
  DEACTIVATE_RAZORPAY_PLAN,
  UPDATE_DOCG_TAX_SETTINGS,
} from "src/components/graphql/GraphQLmutation";
import {
  FETCH_SUBSCRIPTION_BY_ID,
  FETCH_SUBSCRIPTION_PLAN_BY_ID,
  GET_CLINIC_PROFILE,
  GET_DOCG_TAX_SETTINGS,
  LIST_ACTIVE_RAZORPAY_PLANS,
  LIST_ALL_RAZORPAY_PLANS,
  VERIFY_TOKEN,
} from "src/components/graphql/GraphQLquery";

export async function cancelRazorpaySubscription(id) {
  try {
    const response = await postMutation(CANCEL_RAZORPAY_SUBSCRIPTION, id);

    if (
      typeof response === "undefined" ||
      response?.errors ||
      !(
        response?.data?.cancelRazorpaySubscription?.statusCode < 300 &&
        response?.data?.cancelRazorpaySubscription?.statusCode >= 200
      )
    ) {
      throw new Error("error", response);
    } else {
      return true;
    }
  } catch (e) {
    snackbar({
      message: "Some error occured while Cancelling subscription. Try again",
      color: "danger",
    });
    console.error("Error at createRazorpayPlan: ", e);
    return false;
  }
}

export async function createRazorpayPlan(data) {
  try {
    const response = await postMutation(CREATE_RAZORPAY_PLAN, data);

    if (
      typeof response === "undefined" ||
      response?.errors ||
      !(
        response?.data?.createRazorpayPlan?.statusCode < 300 &&
        response?.data?.createRazorpayPlan?.statusCode >= 200
      )
    ) {
      throw new Error(response?.data?.createRazorpayPlan?.message);
    } else {
      snackbar({
        message: "Plan Added successfully.",
        color: "success",
      });
      return true;
    }
  } catch (e) {
    snackbar({
      message: e?.message || "Some error occured while Adding Plan. Try again",
      color: "danger",
    });
    console.error("Error at createRazorpayPlan: ", e);
    return false;
  }
}

export async function deactivateAllRazorpayPlan(subscriptionType) {
  try {
    const response = await postMutation(
      DEACTIVATE_RAZORPAY_PLAN,
      { subscriptionType },
      true
    );

    if (
      typeof response === "undefined" ||
      response?.errors ||
      !(
        response?.data?.deactivateAllRazorpayPlan?.statusCode < 300 &&
        response?.data?.deactivateAllRazorpayPlan?.statusCode >= 200
      )
    ) {
      throw new Error(response?.data?.deactivateAllRazorpayPlan?.message);
    } else {
      snackbar({
        message: subscriptionType + " Plans Deactivated successfully.",
        color: "success",
      });
      return true;
    }
  } catch (e) {
    snackbar({
      message: e?.message || "Some error occured while deactivating plans.",
      color: "danger",
    });
    console.error("Error at deactivateAllRazorpayPlan: ", e);
    return false;
  }
}

export async function listAllRazorpayPlans() {
  try {
    const response = await getQuery(LIST_ALL_RAZORPAY_PLANS);

    if (
      typeof response === "undefined" ||
      response?.errors ||
      !(
        response?.data?.listAllRazorpayPlans?.statusCode < 300 &&
        response?.data?.listAllRazorpayPlans?.statusCode >= 200
      )
    ) {
      throw new Error("error", response);
    } else {
      // snackbar({
      //   message: "Account Added successfully.",
      //   color: "success",
      // });
      return response?.data?.listAllRazorpayPlans?.data;
    }
  } catch (e) {
    snackbar({
      message: e.message || "Error fetching all Razorpay Plans",
      color: "danger",
    });
    console.error("Error at listAllRazorpayPlans: ", e.msg);
    return [];
  }
}

export async function listActiveRazorpayPlans() {
  try {
    const response = await getQuery(LIST_ACTIVE_RAZORPAY_PLANS);

    if (
      typeof response === "undefined" ||
      response?.errors ||
      !(
        response?.data?.listAllRazorpayPlans?.statusCode < 300 &&
        response?.data?.listAllRazorpayPlans?.statusCode >= 200
      )
    ) {
      throw new Error("error", response);
    } else {
      // snackbar({
      //   message: "Account Added successfully.",
      //   color: "success",
      // });
      return response?.data?.listAllRazorpayPlans?.data;
    }
  } catch (e) {
    snackbar({
      message: e.message || "Some error occured while fetching active plans",
      color: "danger",
    });
    console.error("Error at listAllRazorpayPlans: ", e.msg);
    return [];
  }
}

export async function getClinicProfile(data) {
  try {
    const response = await getQuery(GET_CLINIC_PROFILE, { id: data });
    if (
      typeof response == "undefined" ||
      response?.errors ||
      !(
        response?.data?.getClinicProfile?.statusCode >= 200 &&
        response?.data?.getClinicProfile?.statusCode < 300
      )
    ) {
      throw new Error("error", response);
    } else {
      if (response?.data?.getClinicProfile?.data) {
        return response?.data?.getClinicProfile?.data;
      } else {
        throw new Error("error", response);
      }
    }
  } catch (e) {
    snackbar({
      message: e.message || "Some error occured while fetching Clinic information",
      color: "danger",
    });
    console.error("Error at fetching Clinic information ", e);
    return [];
  }
}

export async function fetchSubscriptionById(id) {
  try {
    const response = await getQuery(FETCH_SUBSCRIPTION_BY_ID, id);
    if (
      typeof response == "undefined" ||
      response?.errors ||
      !(
        response?.data?.fetchSubscriptionById?.statusCode >= 200 &&
        response?.data?.fetchSubscriptionById?.statusCode < 300
      )
    ) {
      throw new Error("error", response);
    } else {
      if (response?.data?.fetchSubscriptionById?.data) {
        return response?.data?.fetchSubscriptionById?.data;
      } else {
        throw new Error("error", response);
      }
    }
  } catch (e) {
    snackbar({
      message: e.message || "Some error occured while fetching subscription",
      color: "danger",
    });
    console.error("Error at fetchSubscriptionById ", e);
    return [];
  }
}

export async function fetchSubscriptionPlanById(id) {
  try {
    const response = await getQuery(FETCH_SUBSCRIPTION_PLAN_BY_ID, id);
    if (
      typeof response == "undefined" ||
      response?.errors ||
      !(
        response?.data?.fetchSubscriptionPlanById?.statusCode >= 200 &&
        response?.data?.fetchSubscriptionPlanById?.statusCode < 300
      )
    ) {
      throw new Error("error", response);
    } else {
      if (response?.data?.fetchSubscriptionPlanById?.data) {
        return response?.data?.fetchSubscriptionPlanById?.data;
      } else {
        throw new Error("error", response);
      }
    }
  } catch (e) {
    snackbar({
      message: e.message || "Some error occured while fetching subscription plan",
      color: "danger",
    });
    console.error("Error at fetchSubscriptionPlanById ", e);
    return {};
  }
}

//verify turnstile token
export async function verifyTurnstileToken(data) {
  try {
    const response = await postMutationUnAuth(VERIFY_TOKEN, data);
    if (typeof response === "undefined") {
      throw new Error("error", response);
    } else {
      if (
        response.data.verifyTurnstile.statusCode < 300 &&
        response.data.verifyTurnstile.statusCode >= 200
      ) {
        return response.data.verifyTurnstile.data;
      } else {
        throw new Error(response);
      }
    }
  } catch (error) {
    console.error("Error at verifying turnstile token: ", error);
  }
}

export async function getDocgTaxSettings() {
  try {
    const response = await getQuery(GET_DOCG_TAX_SETTINGS);
    const result = response?.data?.getDocgTaxSettings;
    if (result?.statusCode >= 200 && result?.statusCode < 300 && result?.data) {
      return result.data;
    }
    throw new Error(result?.message || "Failed to load tax settings");
  } catch (e) {
    snackbar({
      message: e.message || "Error fetching GST tax settings",
      color: "danger",
    });
    return null;
  }
}

export async function updateDocgTaxSettings(data) {
  try {
    const response = await postMutation(UPDATE_DOCG_TAX_SETTINGS, data);
    const result = response?.data?.updateDocgTaxSettings;
    if (result?.statusCode >= 200 && result?.statusCode < 300) {
      snackbar({ message: "Tax settings saved.", color: "success" });
      return result.data;
    }
    throw new Error(result?.message || "Failed to update tax settings");
  } catch (e) {
    snackbar({
      message: e?.message || "Error saving tax settings",
      color: "danger",
    });
    return null;
  }
}